import type { CeilingBase, Flat, None, TrayFreeform, TraySimpleOffset, Vaulted } from "building-types/ceilings/ceiling";
import { CeilingBoundaryType, CeilingRidgeOrientation, CeilingType, HeightType } from "building-types/ceilings/ceiling";
import { makeBuiltInLabelTable } from "../utils/labelTools";

const defaultTrayCeilingLabels = makeBuiltInLabelTable(
  "addToElectricalPlan",
  "addToFloorPlan",
  "addToStructuralPlan",
  "addToShowroomPlan",
  "addToBrochurePlan",
);

const defaultCeilingBase: CeilingBase = {
  labels: defaultTrayCeilingLabels,
};

export const defaultTrayCeilingSimple: TraySimpleOffset = {
  type: CeilingType.TRAY_SIMPLE_OFFSET,
  ...defaultCeilingBase,
  heightType: HeightType.OFFSET_FROM_CEILING,
  height: 12,
  boundaryType: CeilingBoundaryType.MAX_RECTANGLE,
  offset: 24,
};

export const defaultTrayCeilingFreeForm: TrayFreeform = {
  type: CeilingType.TRAY_FREEFORM,
  ...defaultCeilingBase,
  heightType: HeightType.OFFSET_FROM_CEILING,
  height: 12,
  outline: null,
};

export const defaultVaultedCeiling: Vaulted = {
  ...defaultCeilingBase,
  type: CeilingType.VAULTED,
  boundaryType: CeilingBoundaryType.INSIDE_OF_FRAMING,
  ridgeOrientation: CeilingRidgeOrientation.AUTO,
  slope: 0.5,
  ridge: 0.5,
  offset: 0,
};

export const defaultNoneCeiling: None = {
  type: CeilingType.NONE,
  ...defaultCeilingBase,
  outline: null,
  boundaryType: CeilingBoundaryType.INSIDE_OF_FRAMING,
  offset: 0,
};

export const defaultFlatCeiling: Flat = {
  type: CeilingType.FLAT,
  ...defaultCeilingBase,
};

export const ceilingTypeToDefaultProps: { [key in CeilingType]: CeilingBase } = {
  [CeilingType.TRAY_SIMPLE_OFFSET]: defaultTrayCeilingSimple,
  [CeilingType.TRAY_FREEFORM]: defaultTrayCeilingFreeForm,
  [CeilingType.VAULTED]: defaultVaultedCeiling,
  [CeilingType.NONE]: defaultNoneCeiling,
  [CeilingType.FLAT]: defaultFlatCeiling,
};
